// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-edit-name-modal',
    templateUrl: './edit-name-modal.component.html',
    styleUrls: ['./edit-name-modal.component.scss'],
})
export class EditNameModalComponent implements OnInit, OnDestroy {
    public title = 'Edit Document';
    public label = 'Name';

    public isComponentAlive = true;
    public isChecked = false;

    private noSpaceOnlyRegex = /^(?!\s+$)[\s\S]*$/;

    public form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required, Validators.pattern(this.noSpaceOnlyRegex)]),
    });

    constructor(
        private dialogRef: MatDialogRef<EditNameModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        if (this.data.isDealerOnly) {
            this.isChecked = true;
        } else {
            this.isChecked = false;
        }

        if (this.data?.title) {
            this.title = this.data.title;
        }

        if (this.data?.label) {
            this.label = this.data.label;
        }

        if (this.data?.value) {
            this.form.setValue(this.data.value);
        }
    }

    toggleIsChecked() {
        this.isChecked = !this.isChecked;
    }

    public submit() {
        this.form.markAllAsTouched();
        if (this.form.valid) {
            this.dialogRef.close({
                update: true,
                newName: this.form.controls.name.value,
                isDealerOnly: this.isChecked,
            });
        }
    }

    public close() {
        this.dialogRef.close();
    }

    ngOnDestroy(): void {
        this.form.patchValue({ name: '', isDealerOnly: false });
        this.isComponentAlive = false;
    }
}
